<template>
  <div class="panel">
    <div :class="title_valid_cls">
      <div class="gray100" v-if="qtype == '3'">
        <b-form-group label="추가문제유형">
          <b-form-radio-group
            v-model="q_type_sub"
            :options="q_type_sub_options"
            name="radio-s-type"
          ></b-form-radio-group>
        </b-form-group>
      </div>

      <b-form-group
        label-for="input-qstatement"
        label-cols-sm="4"
        label-cols-lg="2"
        label="개별 지시문"
      >
        <b-form-input id="input-qstatement" v-model="qstatement"></b-form-input>
      </b-form-group>

      <div>문제 *</div>
      <Editor
        ref="editor8"
        v-on:processing="appendAnswer"
        v-on:processing2="appendQType2Answer"
        v-on:processing3="appendQType3Answer"
        v-on:processing4="appendQType4Answer"
        func="updateQTitle"
        :content="title"
      />
    </div>

    <div v-if="qtype == '1'">
      <QType1Answer
        :answer="answer"
        v-bind:key="answer.id"
        v-for="answer in answers"
      />
      <b-row :class="nocount_qtype1_valid_cls">
        <b-col>
          <b-form-group>
            <b-button block size="sm" @click="appendAnswer('')">
              정답추가(+)
            </b-button>
          </b-form-group>
        </b-col>
      </b-row>

      <div :class="intent1_valid_cls">
        <b-row>
          <b-col>출제포인트*</b-col>
        </b-row>
        <div class="multisel_wrapper bspace">
          <multiselect
            v-model="intent1"
            :options="intent_options"
            :custom-label="nameWithLang"
            placeholder="출제포인트1(필수)"
            label="name"
            track-by="name"
          ></multiselect>
        </div>
        <div class="multisel_wrapper bspace">
          <multiselect
            v-model="intent2"
            :options="intent_options"
            :custom-label="nameWithLang"
            placeholder="출제포인트2"
            label="name"
            track-by="name"
          ></multiselect>
        </div>
        <div class="multisel_wrapper bspace">
          <multiselect
            v-model="intent3"
            :options="intent_options"
            :custom-label="nameWithLang"
            placeholder="출제포인트3"
            label="name"
            track-by="name"
          ></multiselect>
        </div>
      </div>
    </div>
    <div v-if="qtype == '2'">
      <QType2Answer />
    </div>
    <div v-if="qtype == '3'">
      <QType3Answer />
    </div>
    <div v-if="qtype == '4'">
      <QType4Answer />
    </div>

    <div v-if="qtype == '5'">
      <QType5Answer />
    </div>

    <div v-if="qtype == '6'">
      <QType6Answer />
    </div>

    <div v-if="qtype == '7'">
      <QType7Answer />
    </div>

    <div v-if="qtype == '8'">
      <QType8Answer />
    </div>

    <b-row>
      <b-col>
        <FileUpload utype="image" fileobj="image" />
      </b-col>
    </b-row>

    <div v-if="std_type != 3">
      <VideoForm :video="video" :key="video.id" v-for="video in videos" />

      <b-row>
        <b-col>
          <b-form-group>
            <b-button block size="sm" @click="appendVideo">
              동영상추가(+)
            </b-button>
          </b-form-group>
        </b-col>
      </b-row>
    </div>

    <b-row>
      <b-col>
        <FileUpload utype="sound" fileobj="sound" />
      </b-col>
    </b-row>

    <LevelForm />

    <b-row>
      <b-col sm="6" lg="6" v-show="1 == 2">
        <b-form-group
          label="어휘레벨:"
          label-cols-sm="3"
          label-cols-lg="2"
          label-for="input-wordlevel"
        >
          <b-form-select
            id="input-wordlevel"
            v-model="word_level"
            :options="word_level_options"
          ></b-form-select>
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group
          label="기출정보:"
          label-cols-sm="3"
          label-cols-lg="2"
          label-for="input-previnfo"
        >
          <b-form-input id="input-previnfo" v-model="prevtest_info" />
        </b-form-group>
      </b-col>
    </b-row>
    <b-button @click="binddic()" v-show="1 == 2">레벨체크</b-button>

    <!-- std_type  맞춰 보여주고 안보여주고를 해야함 -->

    <div
      style="text-align: left; margin-bottom: 10px"
      v-if="questionform.id != ''"
    >
      <b-button
        @click="openDup()"
        size="sm"
        style="width: 100%"
        variant="danger"
        >중복문항 체크</b-button
      >
    </div>

    <b-row>
      <b-col class="button_wrapper">
        <b-button
          @click="save"
          size="sm"
          variant="primary"
          class="float-right"
          >{{ saveorupdate_title }}</b-button
        >
        <b-button @click="cancel" size="sm" variant="danger" class="float-right"
          >취소</b-button
        >
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Editor from "@/components/Editor";
import QType1Answer from "@/components/question/QType1Answer";
import QType2Answer from "@/components/question/QType2Answer";
import QType3Answer from "@/components/question/QType3Answer";
import QType4Answer from "@/components/question/QType4Answer";
import QType5Answer from "@/components/question/QType5Answer";
import QType6Answer from "@/components/question/QType6Answer";
import QType7Answer from "@/components/question/QType7Answer";
import QType8Answer from "@/components/question/QType8Answer";
import FileUpload from "@/components/FileUpload";
import VideoForm from "@/components/question/VideoForm";
import LevelForm from "@/components/question/LevelForm";
import Multiselect from "vue-multiselect";

import axios from "axios";
const SERVER_URL = `${process.env.VUE_APP_SERVER_URL}`;

export default {
  components: {
    Editor,
    QType1Answer,
    QType2Answer,
    QType3Answer,
    QType4Answer,
    QType5Answer,
    QType6Answer,
    QType7Answer,
    QType8Answer,
    FileUpload,
    VideoForm,
    LevelForm,
    Multiselect,
  },
  computed: {
    std_type() {
      return this.$store.state.questionmeta.std_type;
    },
    qstatement: {
      get() {
        return this.$store.state.questionform.qstatement;
      },
      set(val) {
        this.$store.commit("updateQStatement", val);
      },
    },

    word_level_options() {
      return this.$store.state.word_level_options;
    },
    word_level: {
      get() {
        return this.$store.state.questionform.word_level;
      },
      set(val) {
        this.$store.commit("updateWordLevel", val);
      },
    },

    nocount_qtype1_valid_cls() {
      return this.$store.state.valid.qtype1_nocount;
    },

    intent1: {
      set(val) {
        this.$store.commit("updateIntent1", val);
      },
      get() {
        return this.$store.state.questionform.intent1;
      },
    },
    intent2: {
      set(val) {
        this.$store.commit("updateIntent2", val);
      },
      get() {
        return this.$store.state.questionform.intent2;
      },
    },
    intent3: {
      set(val) {
        this.$store.commit("updateIntent3", val);
      },
      get() {
        return this.$store.state.questionform.intent3;
      },
    },

    intent_options() {
      return this.$store.state.intent_options;
    },
    intent1_valid_cls() {
      return this.$store.state.valid.intent1;
    },

    q_type_sub: {
      get() {
        return this.$store.state.questionform.q_type_sub;
      },
      set(val) {
        this.$store.commit("updateQTypeSub", val);
      },
    },
    q_type_sub_options() {
      return this.$store.state.q_type_sub_options;
    },

    qtype() {
      return this.$store.state.questionform.q_type;
    },

    saveorupdate_title() {
      // return "저장";
      return this.$store.state.questionform.id == "" ? "저장" : "수정";
    },
    title() {
      return this.$store.state.questionform.title_imsi;
    },

    questionmeta() {
      return this.$store.state.questionmeta;
    },
    questionform() {
      return this.$store.state.questionform;
    },
    qtype1_answers() {
      return this.$store.state.qtype1_answers;
    },

    title_valid_cls() {
      return this.$store.state.valid.title;
    },

    prevtest_info: {
      get() {
        return this.$store.state.questionform.prevtest_info;
      },
      set(val) {
        this.$store.commit("updatePrevtestInfo", val);
      },
    },

    statement: {
      get() {
        return this.$store.state.questionmeta.statement;
      },
      set(val) {
        this.$store.commit("updateStatement", val);
      },
    },
    answers() {
      return this.$store.state.qtype1_answers;
    },
    translate: {
      get() {
        return this.$store.state.questionmeta.translate;
      },
    },
    qcomment() {
      return this.$store.state.questionmeta.qcomment;
    },
    videos() {
      return this.$store.state.questionform.videos;
    },
  },
  methods: {
    async binddic() {
      let title = this.$store.state.questionform.title;
      title = title.replace(/<[^>]*>?/gm, "");
      let titles = title.split(" ");

      let flevel = 3;
      for (let i = 0; i < titles.length; i++) {
        if (titles[i] != "") {
          console.log(titles[i]);
          let url = `${SERVER_URL}/query?q=${titles[i]}`;
          await axios.get(url).then((resp) => {
            let data = resp.data;
            let klvl = 0;
            console.log(data.status);
            if (data.status.indexOf("ico_star1") >= 0) {
              klvl = 1;
            } else if (data.status.indexOf("ico_star2") >= 0) {
              klvl = 2;
            } else if (data.status.indexOf("ico_star3") >= 0) {
              klvl = 3;
            } else {
              console.log("catch here");
              klvl = 0;
            }
            if (flevel > klvl) {
              flevel = klvl;
            }
          });
        }
      }

      this.word_level = flevel + "";
      alert("레벨체크 완료");
    },
    nameWithLang({ d1, d2, d3 }) {
      return `${d1} -> ${d2} -> ${d3}`;
    },
    appendAnswer(seltext) {
      this.$store.dispatch("appendQType1Answer", seltext);
    },
    appendQType2Answer(seltext) {
      // alert(seltext);
      this.$store.dispatch("appendQType2Pick", seltext);
    },
    appendQType3Answer(seltext) {
      this.$store.dispatch("appendQType3Pick", seltext);
    },
    appendQType4Answer(seltext) {},

    appendVideo() {
      this.$store.dispatch("appendVideo");
    },
    async save() {
      let _k = await this.$store.dispatch("saveQType1GroupQuestionOnly");

      if (!_k) {
        alert("폼을 확인해주세요");
        return false;
      } else {
        this.$store.commit("resetQuestionOnly");
      }

      this.$nextTick(() => {
        this.$refs.editor8.reset();
      });
    },
    cancel() {
      this.$refs.editor8.reset();
      this.$store.commit("resetQuestionOnly");
    },
    openDup() {
      this.$nextTick(() => {
        this.$bvModal.show("myiddup");
      });
    },
  },
};
</script>


<style lang="scss" scoped>
@import "@/styles/_variables.scss";

.invalid {
  border: 2px solid red;
}

.button_wrapper {
  button {
    margin-right: 5px;
  }
}

.panel {
  padding: 15px;

  //   background-color: $color1;
  border-radius: 15px;
  margin-bottom: 15px;
  border: 3px solid $gray200;
}

.gray100 {
  background-color: $gray200;
  padding: 10px 15px 10px 15px;
  border-radius: 5px;
  margin-bottom: 10px;
  margin-top: 10px;
}
.multiselect--active {
  z-index: 10;
}
.multiselect__content-wrapper {
  z-index: 10;
}
.bspace {
  margin-bottom: 10px;
}
</style>